module.exports = (s) => {
  return {
    // 小游戏链接备注
    link_remark: {
      type: 'input',
      props: {
        placeholder: '请输入小游戏链接备注',
      },
      value: '',
    },
  };
};

